import { Component, Input, OnChanges, OnInit, AfterViewInit, SimpleChanges, TemplateRef, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { JobService } from 'src/app/services/job.service';
import { JobModel } from 'src/app/services/jobModel';
import { SearchData } from 'src/app/services/searchData';
import { UtilService } from 'src/app/services/util.service';
import { CommonModule } from '@angular/common';
import { TimezoneDatePipe } from '../../../timezone-date.pipe';
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ConnectionTemplateComponent } from '../../../templates/connection-template/connection-template.component';
import { MessageWidgetComponent } from '../../../widget/message-widget/message-widget.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { ScrollIntentGate } from 'src/app/shared/scroll-intent-gate';
@Component({
  selector: 'app-jobs-viewed-by',
  standalone: true,
  imports: [CommonModule, TimezoneDatePipe, CommonSkeletonComponent, InfiniteScrollModule,
ConnectionTemplateComponent, MessageWidgetComponent,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './jobs-viewed-by.component.html',
  styleUrls: ['./jobs-viewed-by.component.scss'],
  inputs: ['jobDetails']
})
export class JobsViewedByComponent implements OnDestroy, OnInit, OnChanges ,AfterViewInit {
  // User-intent gate (src/app/shared/scroll-intent-gate.ts): after a page
  // lands, the next page needs a NEW physical input — a fast wheel flick's
  // smooth-scroll tail must not chain pages on its own.
  readonly scrollGate = new ScrollIntentGate({
    onArmAtBottom: () => this.onScrollDown(),
    isAtBottom: () => ScrollIntentGate.nearBottom(document.querySelector('.jc-v3-entity-details-body')),
  });

  @Input() designVersion: string = 'v2';
  @ViewChild('scrollSentinel') scrollSentinel: ElementRef;
  private intersectionObserver: IntersectionObserver | null = null;
  jobId: any;
  values: any;
  counterpartsDetails: any;
  jobDetails: JobModel
  url = AppSettings.photoUrl;
  connectionRequestRef: BsModalRef;
  LoginUserId = localStorage.getItem('userId')
  connectionStatus: string;
  constructor(private api: ApiService, private searchData: SearchData, private modalService: BsModalService, private router: Router, private util: UtilService,
    private a_route: ActivatedRoute, private JobServicecolor: JobService) {
    this.a_route.queryParams.subscribe(res => {
      this.jobId = res.jobId
    })
    this.searchData.setNUllCheck("jobs-viewed");
  }
  // ngOnChanges(changes: SimpleChanges): void {
  //   if (changes.jobDetails.currentValue) {
  //     this.jobDetails = changes.jobDetails.currentValue;
  //     if (this.jobDetails.jobId) {
  //       this.viewedList = [];
  //       this.searchConfig.pageNumber = 0;
  //       this.getViews()
  //     }
  //   }
  // }
  ngAfterViewInit(): void {
    this.setupScrollObserver();
  }

   private setupScrollObserver(): void {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      this.intersectionObserver = null;
    }
    if (!this.scrollSentinel?.nativeElement) return;

    this.intersectionObserver = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          this.onScrollDown();
        }
      },
      { root: null, rootMargin: '200px', threshold: 0 }
    );
    this.intersectionObserver.observe(this.scrollSentinel.nativeElement);
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.jobDetails && changes.jobDetails.currentValue) {
      this.jobDetails = changes.jobDetails.currentValue;
      if (this.jobDetails.jobId) {
        this.viewedList = [];
        this.searchConfig.pageNumber = 0;
        this.stopscrollFlag = false;
        // Invalidate any in-flight page fetch and unlock the loadAPIcall
        // entry guard — a tab re-click during pagination must reload
        // fresh, not skip + append the stale page into the cleared list.
        this.fetchGeneration++;
        this.loadAPIcall = false; this.scrollGate.pageLanded();
        this.getViews()
      }
    }
      setTimeout(() => this.setupScrollObserver());
  }
  viewedList: any = []
  ngOnInit() {

    this.scrollGate.attach();
    this.viewedList = [];
    this.scrollSubject.pipe(
      debounceTime(100)
    ).subscribe(() => {
      if (this.loadAPIcall || this.stopscrollFlag) return;
      this.getViews();
    });
  }
  ngOnDestroy(): void {

    this.scrollGate.detach();
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
    this.scrollSubject.complete();
  }
  getInitialstwo(firstname: string, lastname: string): string {
    return this.JobServicecolor.getInitialsparam(firstname, lastname);
  }
  getColortwo(firstname: string, lastname: string): string {
    return this.JobServicecolor.getColorparam(firstname, lastname);
  }
  getTextColor(firstname: string, lastname: string): string {
    return this.JobServicecolor.getTextColor(firstname, lastname);
  }
  searchConfig: any = {
    pageNumber: 0,
  }
  profile(val) {
    let values: any = {}
    values.userId = val;
    this.router.navigate(["personalProfile"], { queryParams: values });
  }
  loadAPIcall:boolean=false;
  // Stale-response gate: bumped on every list reset (tab re-click). A fetch
  // captures the value at launch; a reset mid-flight makes the late response
  // a no-op instead of appending old rows into the cleared list.
  private fetchGeneration = 0;
  getViews() {
    if (this.loadAPIcall) return;
    const jobId = this.jobDetails.jobId;
    this.searchConfig = { ...this.searchConfig, jobId, limit: 10, };
    // this.util.startLoader();
    this.loadAPIcall=true;
    const gen = this.fetchGeneration;
    this.api.create('jobs/findJobsViewedBy', this.searchConfig).subscribe(
      res => { if (gen !== this.fetchGeneration) return; this.handleResponse(res); },
      err => { if (gen !== this.fetchGeneration) return; this.handleError(err); }
    );
  }
  handleResponse(res) {
    // this.util.stopLoader();
    this.loadAPIcall = false; this.scrollGate.pageLanded();if (res.code !== '00000' || !res.data || !res.data.viewedByList.length) {
      this.stopscrollFlag = true;
      return;
    }
    if (res.code == '00000') {
      if (res.data.viewedByList.length < 9) {
        this.stopscrollFlag = true;
      } else {
        this.stopscrollFlag = false;
        this.searchConfig.pageNumber++;
      }
      res.data.viewedByList.forEach(element => {
        if (element.logo != undefined) {
          element.logo = AppSettings.photoUrl + element.logo;
        } else {
          element.logo = null;
        }
        this.viewedList.push(element)
      });
    }
  }
  handleError(err) {
    // this.util.stopLoader();
    this.loadAPIcall = false; this.scrollGate.pageLanded();}
  stopscrollFlag: boolean = false
  scrollSubject = new Subject<void>();
  onScrollDown() {
    if (!this.loadAPIcall && !this.stopscrollFlag && this.scrollGate.armed) {
      this.scrollSubject.next();
    }
  }
  chatuser(values, connectionTemplate?: TemplateRef<any>) {
    if (values.connectionStatus === 'CONNECTED') {
      this.openMessage(values)
    } else if (values.connectionStatus !== 'CONNECTED') {
      this.openMessage(values)
      // to be used later
      // this.openConnectionTemplate(values.connectionStatus, values, connectionTemplate);
    }
  }
  seletedChatItem: any;
  messageData: any;
  userId = localStorage.getItem('userId');
  messagemodelflag: any;
  openMessage(seletedItem) {
    if (seletedItem.userId == this.userId) {
      seletedItem.owner = true;
    } else {
      seletedItem.owner = false;
    }
    setTimeout(() => {
      seletedItem.userId = seletedItem.userId;
      this.seletedChatItem = seletedItem;
      this.messageData = [];
      this.messagemodelflag = true;
      seletedItem.groupType = "USER";
      seletedItem.messageType = "USER";
      seletedItem.id = seletedItem.userId;
      seletedItem.onlyuser = "USER";
      this.messageData = seletedItem;
    }, 1000);
  }
  closeMessage(event) {
    this.messagemodelflag = false;
  }
  openConnectionTemplate(connectionStatus, values, connectionTempate?: TemplateRef<any>) {
    this.connectionStatus = connectionStatus;
    this.values = values;
    const initialState: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: 'sm',
    };
    this.api.query("user/" + this.values.userId).subscribe(res => {
      if (res.code == '00000') {
        this.counterpartsDetails = res;
        this.connectionRequestRef = this.modalService.show(connectionTempate, initialState);
      }
    })
  }
}
